import { render, staticRenderFns } from "./OnBoardRequestDetail.vue?vue&type=template&id=63a5088f&scoped=true&"
import script from "./OnBoardRequestDetail.vue?vue&type=script&lang=js&"
export * from "./OnBoardRequestDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a5088f",
  null
  
)

export default component.exports